const LOYALTY_API_BASE = '/api/loyalty';

export const LOYALTY_ENDPOINTS = {
    BALANCE: LOYALTY_API_BASE + '/balance',
    CONFIG_DETAILS: LOYALTY_API_BASE + '/loyalty-details',
    REWARD_DETAILS: LOYALTY_API_BASE + '/reward-details',
} as const;
